<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header d-block">
                <h1 class="text">{{this.$route.meta.title}}</h1>
                <div class="card-header-action mt-3 card-report">
                    <button v-b-modal.bv-modal-Sorting type="button" class="btn btn-light">
                        Selected historys from {{sorting_date}}
                        <i class="ml-2 align-middle uil uil-angle-down"></i>
                    </button>
                </div>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="loading === true">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>

                    <div class="col-12" v-if="loading === false">
                        <div class="activities">
                            <div class="activity" v-for="data in historys" :key="data.id">
                                <div class="activity-icon bg-primary text-white shadow-primary">
                                    <i class="uil uil-history"></i>
                                </div>
                                <div class="activity-detail">
                                    <div class="mb-2">
                                        <span class="text-job text-primary">{{data.created_at | formatDate}}</span>
                                    </div>
                                    <p>
                                        <template v-if="data.send.level === 1">Admin</template>
                                        <template v-if="data.send.level === 2">Distributor</template>
                                        <strong> {{data.send.name}}</strong> send <strong>{{data.slot}} slot</strong> to
                                        <template v-if="data.receiver.level === 2">distributor</template>
                                        <template v-if="data.receiver.level === 3">agent</template>
                                        <strong> {{data.receiver.name}}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <b-modal id="bv-modal-Sorting" centered hide-header hide-footer>
            <div class="form-row mt-4">

                <div class="form-group col-md-12">
                    <label>Historys Type</label>
                    <v-select :clearable="false" label="label" :reduce="sorting_type => sorting_type.value" v-model="sorting_report.date_type" :options="sorting_type"></v-select>
                </div>

                <template v-if="sorting_report.date_type === 'custom'">
                    <div class="form-group col-md-12">
                        <label>Start Date</label>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="uil uil-calendar-alt"></i>
                                </div>
                            </div>
                            <datetime v-model="sorting_report.start_date" type="date" input-class="form-control"></datetime>
                        </div>
                    </div>

                    <div class="form-group col-md-12">
                        <label>End Date</label>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="uil uil-calendar-alt"></i>
                                </div>
                            </div>
                            <datetime :min-datetime="sorting_report.start_date" v-model="sorting_report.end_date" type="date" input-class="form-control"></datetime>
                        </div>
                    </div>
                </template>

                <div class="form-group col-md-12 mb-0">
                    <button v-on:click="sortingReports()" class="btn btn-new"><i class="uil uil-search mr-1"></i> Search Historys</button>
                </div>
            </div>

        </b-modal>

    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import moment from 'moment'
    import { Datetime } from 'vue-datetime';
    import vSelect from 'vue-select'

    export default {
        data() {
            return {
                loading:false,
                sorting_date:'',
            }
        },
        mounted(){
            this.loading = true
            this.getHistorys().then(() => {
                this.loading = false
            })
            this.sortingType()
        },
        components: {
            Datetime,
            vSelect,
        },
        computed:{
            ...mapState('DashboardControl', {
                sorting_type: state => state.sorting_type,
                sorting_report: state => state.sorting_report,
                historys: state => state.historys,
            }),
            ...mapState('AuthControl', {
                user: state => state.user,
            }),
            
        },
        filters: {
            formatDate: function(val){
                return moment(String(val)).format('DD MMMM YYYY HH:mm:ss')
            }
        },
        methods:{
            ...mapActions('DashboardControl', ['getHistorys']),
            ...mapMutations('DashboardControl', ['CLEAR_SORTING_REPORT','CLEAR_HISTORYS']),

           sortingType: function(){
                if(this.sorting_report.date_type != 'custom'){
                    this.sorting_type.forEach(data => {
                        if(data.value == this.sorting_report.date_type){
                            this.sorting_date = data.label
                        }
                    });
                }else{
                    this.sorting_date = moment(String(this.sorting_report.start_date)).format('DD MMMM YYYY')   + ' - ' + moment(String(this.sorting_report.end_date)).format('DD MMMM YYYY')
                }
            },
            sortingReports: function(){
                this.getHistorys();
                this.sortingType();
                this.$bvModal.hide('bv-modal-Sorting')
            },
    
        },
        destroyed(){
            this.CLEAR_SORTING_REPORT()
            this.CLEAR_HISTORYS()
        }
    }
</script>